import { Box, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

import styles from "../styles";

const ProCard = () => {
  const { plans, subscription } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();
  if (!plans) return <></>;

  const hasPromo = subscription?.bannerPromoCode?.applicablePlans?.includes(
    Plans.PRO_YEARLY,
  );

  return (
    <Box sx={[styles.card, { backgroundColor: "primary.main" }]}>
      <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
        11x more likely to land a deal
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Typography sx={styles.planName} variant="h4" alignItems="flex-end">
          Pro
        </Typography>

        <Grid item xs="auto">
          <Grid
            item
            xs={12}
            sx={styles.startAtText}
            justifyContent="flex-start"
            container
          >
            Starts at <br />
          </Grid>
          <Grid item sx={styles.priceText}>
            {hasPromo && (
              <Box component="span">${getPrice(Plans.PRO_YEARLY)}</Box>
            )}{" "}
            <Box component="span" sx={hasPromo ? styles.strike : {}}>
              ${plans && plans[Plans.PRO_YEARLY]?.price}/mo
            </Box>
          </Grid>
          {subscription?.bannerPromoCode?.dateEnding && (
            <Grid item xs={12} justifyContent="flex-end" container>
              <Typography sx={{ color: "#d95e58", fontSize: 11 }}>
                until {subscription?.bannerPromoCode?.dateEnding}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProCard;
